import FlashLib from 'flashlib_onlyplay';
import eGameMode from '../enums/eGameMode';

export default class ControllerReelsBackground extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this._frames = {
      [eGameMode.EGM_REGULAR]: 1,
      [eGameMode.EGM_BONUS]: 2,
    };
  }

  set mode(mode) {
    this.goToFrame(this._frames[mode]);
  }
}
